// Mock data for testing the multi-exchange portfolio tracker
// This simulates realistic cryptocurrency holdings across different exchanges

export const mockBinanceData = [
  { asset: 'BTC', free: '0.853241', locked: '0.146759', usdValue: 65432.10 },
  { asset: 'ETH', free: '5.2341', locked: '1.7659', usdValue: 19876.54 },
  { asset: 'BNB', free: '42.56', locked: '7.44', usdValue: 12345.67 },
  { asset: 'SOL', free: '120.75', locked: '29.25', usdValue: 4321.09 },
  { asset: 'ADA', free: '2500.0', locked: '0.0', usdValue: 876.54 },
  { asset: 'DOT', free: '320.5', locked: '79.5', usdValue: 765.43 },
  { asset: 'LINK', free: '180.25', locked: '19.75', usdValue: 654.32 },
  { asset: 'AVAX', free: '85.3', locked: '14.7', usdValue: 543.21 }
];

export const mockOkxData = [
  { ccy: 'XRP', bal: '5000.000000', eq: '1567.89' },
  { ccy: 'DOGE', bal: '10000.000000', eq: '987.65' },
  { ccy: 'MATIC', bal: '3000.000000', eq: '876.54' },
  { ccy: 'ATOM', bal: '200.000000', eq: '765.43' },
  { ccy: 'UNI', bal: '150.000000', eq: '654.32' },
  { ccy: 'SAND', bal: '1000.000000', eq: '543.21' }
];

// Empty mock data for Hyperliquid since we removed demo mode
export const mockHyperliquidData = {
  spot: [],
  perpetual: [],
  positions: []
};

export const mockAsterData = [
  { asset: 'ASTR', available: '15000.000000', locked: '5000.000000', usdValue: 2000.00 },
  { asset: 'ETH', available: '1.500000', locked: '0.500000', usdValue: 6400.00 }
];

export const mockDefiData = [
  { token: 'WBTC', balance: '0.150000', usdValue: 5432.10 },
  { token: 'AAVE', balance: '25.000000', usdValue: 4321.09 },
  { token: 'CRV', balance: '500.000000', usdValue: 3210.98 },
  { token: 'MKR', balance: '5.000000', usdValue: 2109.87 },
  { token: 'COMP', balance: '15.000000', usdValue: 1098.76 }
];

// Combined mock data for testing
export const mockAllData = [
  ...mockBinanceData.map(asset => ({
    symbol: asset.asset,
    amount: parseFloat(asset.free) + parseFloat(asset.locked),
    price: asset.usdValue / (parseFloat(asset.free) + parseFloat(asset.locked)),
    value: asset.usdValue,
    source: 'binance'
  })),
  ...mockOkxData.map(asset => ({
    symbol: asset.ccy,
    amount: parseFloat(asset.bal),
    price: asset.eq / parseFloat(asset.bal),
    value: asset.eq,
    source: 'okx'
  })),
  ...mockHyperliquidData.spot.map(asset => ({
    symbol: asset.coin,
    amount: parseFloat(asset.amount),
    price: asset.usdValue / parseFloat(asset.amount),
    value: asset.usdValue,
    source: 'hyperliquid-spot'
  })),
  ...mockHyperliquidData.perpetual.map(asset => ({
    symbol: asset.coin,
    amount: parseFloat(asset.amount),
    price: asset.usdValue / parseFloat(asset.amount),
    value: asset.usdValue,
    source: 'hyperliquid-perpetual'
  })),
  ...mockHyperliquidData.positions.map(asset => ({
    symbol: asset.coin,
    amount: parseFloat(asset.size),
    price: asset.entryPrice,
    value: asset.unrealizedPnL,
    source: 'hyperliquid-position'
  })),
  ...mockAsterData.map(asset => ({
    symbol: asset.asset,
    amount: parseFloat(asset.available) + parseFloat(asset.locked),
    price: asset.usdValue / (parseFloat(asset.available) + parseFloat(asset.locked)),
    value: asset.usdValue,
    source: 'aster'
  })),
  ...mockDefiData.map(asset => ({
    symbol: asset.token,
    amount: parseFloat(asset.balance),
    price: asset.usdValue / parseFloat(asset.balance),
    value: asset.usdValue,
    source: 'defi'
  }))
];